// build-default-params.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, Params } from '@angular/router';

import { LocationService } from '@usheru-hff/sdk/location';

/**
 * Usage:
 *   canActivate: [buildDefaultParamsGuard({ key1:'v1', key2:'v2' })]
 */
export function buildDefaultParamsGuard(defaults: Params, useLocCountry = false): CanActivateFn {
  return (route, state) => {
    const router = inject(Router);
    const locationService = useLocCountry ? inject(LocationService) : null;

    const locCountryPart: Params =
      useLocCountry && locationService ? { locCountry: locationService.selectedCountry.slug } : {};

    const targetParams: Params = { ...defaults, ...locCountryPart };

    const qp = route.queryParams;
    let allPresent = true;
    for (const key of Object.keys(targetParams)) {
      if (!(key in qp)) {
        allPresent = false;
        break;
      }
    }
    if (allPresent) return true;

    const tree = router.parseUrl(state.url);
    for (const [k, v] of Object.entries(targetParams)) {
      if (!(k in tree.queryParams)) {
        tree.queryParams[k] = v as string;
      }
    }

    return tree;
  };
}
